import DOMPurify from "dompurify";

export const editorConfiguration = {
    removePlugins: ["Markdown", "MediaEmbedToolbar", "Title"],
    placeholder: "내용을 입력해주세요",
    toolbar: {
        items: [
            "heading",
            "fontFamily",
            "fontSize",
            "|",
            "bold",
            "italic",
            "underline",
            "strikethrough",
            "|",
            "alignment",
            "bulletedList",
            "numberedList",
            "outdent",
            "indent",
            "|",
            "link",
            "imageUpload",
            "insertTable",
            "htmlEmbed",
            "|",
            "undo",
            "redo",
        ],
    },
    fontSize: {
        options: [8, 10, 12, 14, "16 (기본)", 18, 20, 22, 24, 26, 28, 30, 32, 34, 36, 38, 40, 42, 44, 46, 48, 50, 52, 54, 56, 58, 60],
    },
    link: {
        decorators: {
            openInNewTab: {
                mode: "manual",
                label: "Open in a new tab",
                defaultValue: true, // This option will be selected by default.
                attributes: {
                    target: "_blank",
                    rel: "",
                },
            },
        },
    },
    htmlEmbed: {
        // 삽입한 HTML을 에디터 편집 화면에서 렌더링된 미리보기로 보여줌
        showPreviews: true,
        // DOMPurify 기본 정책이 <script>·인라인 이벤트 핸들러·javascript: URL·iframe 등 위험 요소를 제거
        sanitizeHtml(inputHtml: string) {
            const sanitizedHtml = DOMPurify.sanitize(inputHtml);

            return {
                html: sanitizedHtml,
                hasChanged: sanitizedHtml !== inputHtml,
            };
        },
    },
    table: {
        tableProperties: {
            defaultProperties: {
                width: "100%",
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: "rgb(209, 215, 237)",
            },

            // The default styles for table cells in the editor.
            // They should be synchronized with the content styles.
            tableCellProperties: {
                defaultProperties: {
                    // horizontalAlignment: "center",
                    // verticalAlignment: "bottom",
                },
            },
        },
    },
};
